import React from 'react'
import Grid from '@material-ui/core/Grid'
import ProfileOverview from './profile-overview'
import EmptyPage from 'components/empty-page-state'
import PersonOutlineOutlinedIcon from 'components/material-symbol/icons/PersonOutline'
import { gtmEvent } from 'lib/gtm'
import { useHistory } from 'react-router-dom'
import { useStyles } from './styles'

const CoachProfileView = ({ coachProfile }) => {
  const classes = useStyles()
  const history = useHistory()

  const redirectToCreateProfile = () => {
    history.push('/pga-coach/profile/new')
    gtmEvent({
      event: 'formSubmit',
      formCategory: 'coach-profile',
      formAction: 'clicked-create-coach-profile-button',
    })
  }

  return coachProfile != null ? (
    <Grid container spacing={1}>
      <Grid container className={classes.coachProfileCardsContainer}>
        <Grid item xs={12} lg={12} xl={12}>
          <ProfileOverview />
        </Grid>
      </Grid>
    </Grid>
  ) : (
    <EmptyPage
      actionFn={redirectToCreateProfile}
      IconComp={() => <PersonOutlineOutlinedIcon fontSize="large" />}
      title="Coach Profile"
      caption="Your PGA Coach Profile will appear here once completed."
      buttonText="Create Coach Profile"
    />
  )
}

export default CoachProfileView
